export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0063.3dd6b031.webp";